import { Box, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import { SMART_CHARGING_PATHS } from "src/consts/Routes/SmartCharging";
import PageTitle from "src/components/Displays/PageTitle";
import { SMART_CHARGING_ROUTES } from "src/consts/Routes/SmartCharging";
import PageSubTitle from "src/components/Displays/PageSubTitle";
import VerticalLinearProgress, {
  progressMenuSx,
  stepProgressProps,
} from "src/components/ProgressBar/VerticalLinearProgressBar";

const STEPS = ["Start", "Status"] as const;

export const tariffCalculator = (pathname: string) => {
  switch (pathname) {
    case SMART_CHARGING_ROUTES.ADD_EV_START:
      return 40;
    case SMART_CHARGING_ROUTES.ADD_EV_ONBOARDING_CALLBACK:
      return 40;
    default:
      return 90;
  }
};

const activeStep = (pathname: string) => {
  switch (pathname) {
    case SMART_CHARGING_ROUTES.ADD_EV_SUCCESS:
    case SMART_CHARGING_ROUTES.ADD_EV_FAILED:
      return 2;
    default:
      return 1;
  }
};

const AddEvProgressBar = () => {
  const { pathname } = useLocation();

  return (
    <Stack gap="13px" sx={progressMenuSx}>
      <PageTitle text={"Menü"} />
      {SMART_CHARGING_PATHS.includes(pathname) && (
        <Box
          sx={{
            gap: 3,
            height: 55,
            display: { xs: "flex", sm: "default" },
          }}
        >
          <VerticalLinearProgress
            variant="determinate"
            value={90 - tariffCalculator(pathname)}
            {...stepProgressProps(STEPS, activeStep(pathname))}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            {STEPS.map((text) => (
              <PageSubTitle key={text} text={text} />
            ))}
          </Box>
        </Box>
      )}
    </Stack>
  );
};

export default AddEvProgressBar;
